import axios from 'axios'

export default {
  namespaced: true,
  state: {
    workClientProjectsWorkTypePeriodGrid: [],
    workClientProjectsWorkTypePeriodAll_project: [],
    workClientProjectsWorkTypePeriodShow: null,
    pageData: null,
  },
  mutations: {
    setWorkClientProjectsWorkTypePeriodGrid(state, payload) {
      state.workClientProjectsWorkTypePeriodGrid = payload
    },
    setWorkClientProjectsWorkTypePeriodAll_project(state, payload) {
      state.workClientProjectsWorkTypePeriodAll_project = payload
    },
    setWorkClientProjectsWorkTypePeriodShow(state, payload) {
      state.workClientProjectsWorkTypePeriodShow = payload
    },
    setPageData(state, payload) {
      state.pageData = payload
    },
    setDefaultProjectsWorkTypePeriod(state) {
      state.workClientProjectsWorkTypePeriodGrid = []
      state.workClientProjectsWorkTypePeriodAll_project = []
    },
  },
  getters: {
    workClientProjectsWorkTypePeriodGrid: (state) => {
      return state.workClientProjectsWorkTypePeriodGrid
    },
    workClientProjectsWorkTypePeriodAll_project: (state) => {
      return state.workClientProjectsWorkTypePeriodAll_project
    },
    workClientProjectsWorkTypePeriodShow: (state) => {
      return state.workClientProjectsWorkTypePeriodShow
    },
    pageData: (state) => {
      return state.pageData
    },
  },
  actions: {
    onWorkClientProjectsWorkTypePeriodGrid({ commit, rootState }, { limit, page }) {
      return new Promise((resolve, reject) => {
        axios({
          url:
            rootState.apiDomain +
            '/api/admin/work/client/project/work-type/period/grid?limit=' +
            limit +
            '&page=' +
            page,
          method: 'GET',
        })
          .then((resp) => {
            commit('setWorkClientProjectsWorkTypePeriodGrid', resp.data.data)
            commit('setPageData', resp.data)
            resolve(resp)
          })
          .catch((err) => {
            reject(err)
          })
      })
    },
    onWorkClientProjectsWorkTypePeriodAll_project({ commit, rootState }, project_id) {
      return new Promise((resolve, reject) => {
        axios({
          url:
            rootState.apiDomain +
            '/api/admin/work/client/project/work-type/period/grid?limit=0&filter[]=project_id:' +
            project_id,
          method: 'GET',
        })
          .then((resp) => {
            commit('setWorkClientProjectsWorkTypePeriodAll_project', resp.data.data)
            resolve(resp)
          })
          .catch((err) => {
            reject(err)
          })
      })
    },
    onWorkClientProjectsWorkTypePeriodShow({ commit, rootState }, id) {
      return new Promise((resolve, reject) => {
        axios({
          url: rootState.apiDomain + '/api/admin/work/client/project/work-type/period/' + id,
          id: id,
          method: 'GET',
        })
          .then((resp) => {
            commit('setWorkClientProjectsWorkTypePeriodShow', resp.data.data)
            resolve(resp)
          })
          .catch((err) => {
            reject(err)
          })
      })
    },
    onWorkClientProjectsWorkTypePeriodCreate({ rootState }, data) {
      return new Promise((resolve, reject) => {
        axios({
          url: rootState.apiDomain + '/api/admin/work/client/project/work-type/period',
          data: data,
          method: 'POST',
        })
          .then((resp) => {
            resolve(resp)
          })
          .catch((err) => {
            reject(err)
          })
      })
    },
    onWorkClientProjectsWorkTypePeriodCreateMultiple({ rootState }, data) {
      return new Promise((resolve, reject) => {
        axios({
          url: rootState.apiDomain + '/api/admin/work/client/project/work-type/period/multiple',
          data: data,
          method: 'POST',
        })
          .then((resp) => {
            resolve(resp)
          })
          .catch((err) => {
            reject(err)
          })
      })
    },
    onWorkClientProjectsWorkTypePeriodUpdate({ rootState }, data) {
      return new Promise((resolve, reject) => {
        axios({
          url: rootState.apiDomain + '/api/admin/work/client/project/work-type/period',
          data: data,
          method: 'PUT',
        })
          .then((resp) => {
            resolve(resp)
          })
          .catch((err) => {
            reject(err)
          })
      })
    },
    onWorkClientProjectsWorkTypePeriodDelete({ rootState }, { id, checkbox }) {
      return new Promise((resolve, reject) => {
        axios({
          url:
            rootState.apiDomain +
            '/api/admin/work/client/project/work-type/period/' +
            id +
            '?with_relations=' +
            checkbox,
          id: id,
          method: 'DELETE',
        })
          .then((resp) => {
            resolve(resp)
          })
          .catch((err) => {
            reject(err)
          })
      })
    },
  },
}
